import React from 'react';

import '../pages.scss';
import Logo from '../../components/logo.mjs';


const NotFoundPage = () => {
    return (
        <div className="page" id="notFoundPage">
            {Logo()}
            <h1>We can't seem to find this page.</h1>
            <p style={{textAlign: 'center'}}>You may be trying to navigate to a page that no longer exists.</p>
        </div>
    );
}

export default NotFoundPage;